﻿//dans chaque entite, les jours on le même type de quantité
window.cGrpDateNbReservationService = function (bddRef, dataReservationService, lstGrpDateNbReservationService) {

    var Me = this
    this.lstDateNbReservationService = []
    this.dataReservationService = dataReservationService

    this.mGetNbAdulte = function () {
        return this.lstDateNbReservationService[0].lstDataReservationHebergement[0].nb_adulte
    }

    this.mGetNbEnfant = function () {
        return this.lstDateNbReservationService[0].lstDataReservationHebergement[0].nb_enfant
    }

    this.mGetMinDate = function () {
        return this.lstDateNbReservationService[0].date
    }

    this.mGetMaxDate = function () {
        return this.lstDateNbReservationService[this.lstDateNbReservationService.length - 1].date
    }

    this.mGetNbJour = function () {
        var nbJour = 0
        switch (parseInt(dataReservationService.id_type_iteration_service)) {
            //case 0: //1fois
            //    break;
            case 0: //Toutes les nuités
                nbJour = this.lstDateNbReservationService.length
                break;
            case 1: //selection dates
                nbJour = this.lstDateNbReservationService.length
                break;
        }
        return nbJour
    }

    this.mGetLibHtmlDate = function() {
        var libHtml = ""
        var dateMin = Me.mGetMinDate()
        var dateMax = Me.mGetMaxDate()
        if (dateMin.getFullYear() == dateMax.getFullYear()) {
            if (dateMin.getMonth() == dateMax.getMonth()) {
                if (dateMin.getDate() == dateMax.getDate()) {
                    var format = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
                    libHtml += dateMin.dayOfWeekName() + " " + format(dateMin) + ""
                } else {
                    var formatDepart = d => DevExpress.localization.formatDate(d, "dd");
                    var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
                    libHtml += dateMin.dayOfWeekName() + " " + formatDepart(dateMin) + "→" + dateMax.dayOfWeekName() + " " + formatArrive(dateMax)
                }
            } else {
                var formatDepart = d => DevExpress.localization.formatDate(d, "dd/MM");
                var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yyyy");
                libHtml += dateMin.dayOfWeekName() + " " + formatDepart(dateMin) + "→" + dateMax.dayOfWeekName() + " " + formatArrive(dateMax)
            }
        } else {
            var formatDepart = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
            var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
            libHtml += dateMin.dayOfWeekName() + " " + formatDepart(dateMin) + "→" + dateMax.dayOfWeekName() + " " + formatArrive(dateMax)
        }
        return libHtml
    }

    this.mGetLibDetailHtml = function () {
        var txtLig = ""
        if (lstGrpDateNbReservationService.length > 1 || dataReservationService.id_type_iteration_service == 1) {
            //le groupe fait partie de plusieurs grpdateNb
            //on rajoute les dates
            txtLig = this.mGetLibHtmlDate() + " &bull; "
        }
        if (dataReservationService.id_article == 801 || dataReservationService.id_article == 802 || dataReservationService.id_article == 805) {
            //taxe séjour
            txtLig += this.mGetNbJour() + "<i class='fas fa-moon' title='nuité'></i> × "
        } else {
            txtLig += this.mGetNbJour() + "<i class='fas fa-sun' title='journée'></i> × "
        }
        switch (parseInt(dataReservationService.id_type_quantite)) {
            case 0: //saisie
                txtLig += dataReservationService.qte + "<i class='fas fa-barcode'></i>";
                break;
            case 1://nbadulte
                txtLig += this.mGetNbAdulte() + "<i class='fas fa-person' title='adulte'></i>"
                break;
            case 2://nbenfant
                txtLig += this.mGetNbEnfant() + "<i class='fas fa-child-reaching' title='enfant'></i>"
                break;
            case 3://nbadulte+nbenfant
                txtLig += this.mGetNbAdulte() + "<i class='fas fa-person' title='adulte'></i>" + this.mGetNbEnfant() + "<i class='fas fa-child-reaching' title='enfant'></i>"
                break;
        }
        //txtLig += " × " + parseFloat(dataReservationService.puttc).formatDisplay() + "€"
        return txtLig
    }
    this.mGetLibDetailHtmlTooltip = function () {
        var txtLigTooltip = ""
        if (lstGrpDateNbReservationService.length > 1 || dataReservationService.id_type_iteration_service==1) {
            //le groupe fait partie de plusieurs grpdateNb
            //on rajoute les dates
            txtLigTooltip = this.mGetLibHtmlDate() + " &bull; "
        }
        if (dataReservationService.id_article == 801 || dataReservationService.id_article == 802 || dataReservationService.id_article == 805) {
            //taxe séjour
            txtLigTooltip += this.mGetNbJour() + " nuité" + (this.mGetNbJour() > 1 ? "s" : "") + " × "
        } else {
            txtLigTooltip += this.mGetNbJour() + " journée" + (this.mGetNbJour() > 1 ? "s" : "") + " × "
        }
        switch (parseInt(dataReservationService.id_type_quantite)) {
            case 0: //saisie
                txtLigTooltip += dataReservationService.qte + " unité" + (dataReservationService.qte>1 ? "s" : "");
                break;
            case 1://nbadulte
                txtLigTooltip += this.mGetNbAdulte() + " adulte" + (this.mGetNbAdulte() > 1 ? "s" : "")
                break;
            case 2://nbenfant
                txtLigTooltip += this.mGetNbEnfant() + " enfant" + (this.mGetNbEnfant() > 1 ? "s" : "")
                break;
            case 3://nbadulte+nbenfant
                if (this.mGetNbAdulte() > 0) txtLigTooltip += this.mGetNbAdulte() + " adulte" + (this.mGetNbAdulte() > 1 ? "s" : "")
                if (this.mGetNbEnfant() > 0) txtLigTooltip += (txtLigTooltip.length>0 ? "+" : "") + this.mGetNbEnfant() + " enfant" + (this.mGetNbEnfant() > 1 ? "s" : "")
                break;
        }
        //txtLigTooltip += " × " + parseFloat(dataReservationService.puttc).formatDisplay() + "€"
        return txtLigTooltip
    }

    this.mGetTotQte = function () {
        var totQte = 0
        this.lstDateNbReservationService.forEach(function (objDateNbResaService) {
            totQte += objDateNbResaService.mGetQte()
        })
        return totQte
    }
    this.mGetTotTtc = function () {
        var totTtc = 0
        this.lstDateNbReservationService.forEach(function (objDateNbResaService) {
            totTtc += objDateNbResaService.mGetTotTtc()
        })
        return totTtc
    }

}